export default theme => ({
  dialog: {},
  dialogContent: {
    margin: 0,
    padding: theme.spacing(2), 
    overflow: 'auto',
  },
});
